__turbopack_context__.v({
  "active": "BaseButton-module-scss-module__xZCTXG__active",
  "adapt": "BaseButton-module-scss-module__xZCTXG__adapt",
  "block": "BaseButton-module-scss-module__xZCTXG__block",
  "blockOnMobile": "BaseButton-module-scss-module__xZCTXG__blockOnMobile",
  "button": "BaseButton-module-scss-module__xZCTXG__button",
  "centered": "BaseButton-module-scss-module__xZCTXG__centered",
  "centeredOnMobile": "BaseButton-module-scss-module__xZCTXG__centeredOnMobile",
  "dark": "BaseButton-module-scss-module__xZCTXG__dark",
  "defaultSize": "BaseButton-module-scss-module__xZCTXG__defaultSize",
  "disabled": "BaseButton-module-scss-module__xZCTXG__disabled",
  "icon": "BaseButton-module-scss-module__xZCTXG__icon",
  "label": "BaseButton-module-scss-module__xZCTXG__label",
  "large": "BaseButton-module-scss-module__xZCTXG__large",
  "medium": "BaseButton-module-scss-module__xZCTXG__medium",
  "primary": "BaseButton-module-scss-module__xZCTXG__primary",
  "secondary": "BaseButton-module-scss-module__xZCTXG__secondary",
  "small": "BaseButton-module-scss-module__xZCTXG__small",
});
